import React, { useCallback } from 'react';

import { Control } from 'react-hook-form';
import { theme } from '~/theme';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, MenuItem, Stack, Typography } from '@mui/material';

import { Select } from '~/components/Common/Forms/fields';

import { OFFER_FACING_NAMES } from '~/consts/offerTypes';

import { ACCORDION_SECTION_IDS, useAccordionExpanded } from './AccordionExpandedContext';

interface Props {
  control: Control<any>;
  schema: any;
}

const SECTION_ID = ACCORDION_SECTION_IDS.GENERAL_SETTINGS;

const GeneralSettingsAccordion = ({ control, schema }: Props) => {
  const { isSectionExpanded, toggleSection } = useAccordionExpanded();

  const handleChange = useCallback(() => {
    toggleSection(SECTION_ID);
  }, [toggleSection]);

  return (
    <Accordion expanded={isSectionExpanded(SECTION_ID)} onChange={handleChange} disableGutters>
      <AccordionSummary
        aria-controls="general-settings"
        expandIcon={<ExpandMoreIcon />}
        id="general-settings"
        sx={{
          backgroundColor: theme.palette.grey[200],
        }}
      >
        <Typography variant="h5">General Settings</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack mt={2} spacing={2}>
          <Select control={control} name="type" label="Type">
            {schema.properties.type.enum.map((type) => (
              <MenuItem key={type} value={type}>
                {OFFER_FACING_NAMES[type]}
              </MenuItem>
            ))}
          </Select>
          <Select control={control} name="status" label="Status">
            {schema.properties.status.enum.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </Select>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default GeneralSettingsAccordion;
